(function () {
  'use strict';

  var FREE_SHIP_THRESHOLD = 3500;

  /* ── SVG tree stages (vector, no emoji) ── */
  var TREE_SVG = [
    /* 0 – seedling */
    '<svg viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 106 L50 72" stroke="#8D6748" stroke-width="4" stroke-linecap="round"/><path d="M50 78 Q60 62 66 55 Q54 60 50 74" fill="#34D399"/><path d="M50 74 Q40 60 34 53 Q46 58 50 72" fill="#10b981"/><circle cx="50" cy="58" r="10" fill="#059669"/></svg>',
    /* 1 – sapling */
    '<svg viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 106 L50 55" stroke="#7B5E44" stroke-width="5" stroke-linecap="round"/><path d="M50 68 L33 55" stroke="#8D6748" stroke-width="2.5" stroke-linecap="round"/><path d="M50 68 L67 55" stroke="#8D6748" stroke-width="2.5" stroke-linecap="round"/><circle cx="50" cy="42" r="20" fill="#34D399"/><circle cx="33" cy="50" r="13" fill="#10b981"/><circle cx="67" cy="50" r="13" fill="#10b981"/><circle cx="50" cy="30" r="13" fill="#059669"/></svg>',
    /* 2 – growing */
    '<svg viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 106 L50 48" stroke="#6D4C41" stroke-width="7" stroke-linecap="round"/><path d="M50 75 L26 56" stroke="#7B5E44" stroke-width="3.5" stroke-linecap="round"/><path d="M50 75 L74 56" stroke="#7B5E44" stroke-width="3.5" stroke-linecap="round"/><path d="M50 60 L34 44" stroke="#8D6748" stroke-width="2.5" stroke-linecap="round"/><path d="M50 60 L66 44" stroke="#8D6748" stroke-width="2.5" stroke-linecap="round"/><circle cx="50" cy="34" r="24" fill="#34D399"/><circle cx="26" cy="44" r="16" fill="#10b981"/><circle cx="74" cy="44" r="16" fill="#10b981"/><circle cx="36" cy="24" r="14" fill="#059669"/><circle cx="64" cy="24" r="14" fill="#059669"/><circle cx="50" cy="18" r="12" fill="#047857"/><ellipse cx="42" cy="22" rx="8" ry="6" fill="#6EE7B7" opacity="0.4"/></svg>',
    /* 3 – mature */
    '<svg viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 108 L50 40" stroke="#5D4037" stroke-width="9" stroke-linecap="round"/><path d="M50 82 L18 60" stroke="#6D4C41" stroke-width="5" stroke-linecap="round"/><path d="M50 82 L82 60" stroke="#6D4C41" stroke-width="5" stroke-linecap="round"/><path d="M50 66 L28 46" stroke="#7B5E44" stroke-width="3.5" stroke-linecap="round"/><path d="M50 66 L72 46" stroke="#7B5E44" stroke-width="3.5" stroke-linecap="round"/><circle cx="50" cy="28" r="28" fill="#34D399"/><circle cx="18" cy="44" r="19" fill="#10b981"/><circle cx="82" cy="44" r="19" fill="#10b981"/><circle cx="30" cy="20" r="16" fill="#059669"/><circle cx="70" cy="20" r="16" fill="#059669"/><circle cx="50" cy="12" r="16" fill="#047857"/><ellipse cx="38" cy="18" rx="10" ry="7" fill="#6EE7B7" opacity="0.45"/><ellipse cx="62" cy="22" rx="8" ry="6" fill="#A7F3D0" opacity="0.4"/></svg>',
    /* 4 – complete */
    '<svg viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 110 L50 36" stroke="#4E342E" stroke-width="11" stroke-linecap="round"/><path d="M50 88 L14 62" stroke="#5D4037" stroke-width="6" stroke-linecap="round"/><path d="M50 88 L86 62" stroke="#5D4037" stroke-width="6" stroke-linecap="round"/><path d="M50 70 L24 46" stroke="#6D4C41" stroke-width="4" stroke-linecap="round"/><path d="M50 70 L76 46" stroke="#6D4C41" stroke-width="4" stroke-linecap="round"/><path d="M50 54 L36 34" stroke="#7B5E44" stroke-width="2.5" stroke-linecap="round"/><path d="M50 54 L64 34" stroke="#7B5E44" stroke-width="2.5" stroke-linecap="round"/><circle cx="50" cy="24" r="32" fill="#34D399"/><circle cx="14" cy="42" r="21" fill="#10b981"/><circle cx="86" cy="42" r="21" fill="#10b981"/><circle cx="28" cy="16" r="18" fill="#059669"/><circle cx="72" cy="16" r="18" fill="#059669"/><circle cx="50" cy="8" r="18" fill="#047857"/><ellipse cx="36" cy="14" rx="11" ry="8" fill="#6EE7B7" opacity="0.5"/><circle cx="20" cy="32" r="3.5" fill="#fff" opacity="0.75"/><circle cx="80" cy="30" r="3.5" fill="#fff" opacity="0.75"/><circle cx="38" cy="8" r="3" fill="#fff" opacity="0.65"/></svg>'
  ];

  /* ── Category icon config ── */
  var CATS = [
    { k:'cbd',     e:'🌿', g:'135deg,#00C875,#00875A' },
    { k:'wellness',e:'🧘', g:'135deg,#00C875,#00875A' },
    { k:'oel',     e:'💧', g:'135deg,#34AAFF,#0A84FF' },
    { k:'sport',   e:'💪', g:'135deg,#0A84FF,#5856D6' },
    { k:'fitness', e:'🏃', g:'135deg,#0A84FF,#5856D6' },
    { k:'beauty',  e:'🌸', g:'135deg,#FF6B9D,#FF2D55' },
    { k:'haut',    e:'✨', g:'135deg,#FF6B9D,#FF2D55' },
    { k:'outdoor', e:'🌲', g:'135deg,#FF9500,#FF6B00' },
    { k:'garten',  e:'🌱', g:'135deg,#34C759,#00A060' },
    { k:'haus',    e:'🏠', g:'135deg,#8E8E93,#636366' },
    { k:'tier',    e:'🐾', g:'135deg,#FF9500,#BF5700' },
    { k:'hund',    e:'🐶', g:'135deg,#FF9500,#BF5700' },
    { k:'schlaf',  e:'🌙', g:'135deg,#AF52DE,#5856D6' },
    { k:'buecher', e:'📚', g:'135deg,#AF52DE,#5856D6' },
    { k:'tech',    e:'💻', g:'135deg,#636366,#1C1C1E' },
    { k:'eigen',   e:'⭐', g:'135deg,#10b981,#064e3b' },
  ];

  function getCat(handle) {
    var h = handle.toLowerCase();
    for (var i = 0; i < CATS.length; i++) {
      if (h.indexOf(CATS[i].k) >= 0) return CATS[i];
    }
    return { e:'🛍️', g:'135deg,#8E8E93,#3C3C3E' };
  }

  function isHome() {
    var p = window.location.pathname;
    return p === '/' || p === '' ||
           document.body.classList.contains('template-index') ||
           document.body.classList.contains('template--index');
  }

  function getMain() {
    return document.getElementById('MainContent') ||
           document.querySelector('main') ||
           document.body;
  }

  function getAnchor(main) {
    if (main === document.body) {
      return document.querySelector('[id*="shopify-section-template"]') || main.firstChild;
    }
    return main.firstChild;
  }

  var LEAF_SVG =
    '<svg class="fifteen-hero__leaf" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="nwlg" x1="4" y1="2" x2="28" y2="30" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0%" stop-color="#86efac"/>' +
          '<stop offset="50%" stop-color="#22c55e"/>' +
          '<stop offset="100%" stop-color="#15803d"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M16 28 C13 25 7 22 5 18 C3 14 4 9 7 6 C9 4 12 3 14 4 C14.5 4.5 15.2 5.5 16 5.5 C16.8 5.5 17.5 4.5 18 4 C20 3 23 4 25 6 C28 9 29 14 27 18 C25 22 19 25 16 28Z" fill="url(#nwlg)"/>' +
      '<path d="M10 8 C9 10 9 14 11 16" stroke="rgba(255,255,255,0.55)" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M16 27 L16 11" stroke="rgba(255,255,255,0.30)" stroke-width="1.2" stroke-linecap="round"/>' +
      '<path d="M16 28 L16 34" stroke="#15803d" stroke-width="2.5" stroke-linecap="round"/>' +
    '</svg>';

  /* ── Compact header bar ── */
  function injectHero() {
    if (!isHome()) return;
    var main = getMain();
    if (!main || main.querySelector('.fifteen-hero')) return;
    var hero = document.createElement('div');
    hero.className = 'fifteen-hero';
    hero.innerHTML =
      '<div class="fifteen-hero__logo">' + LEAF_SVG + '<span class="fifteen-hero__brand">Nordwald</span></div>' +
      '<a class="fifteen-hero__link" href="/collections/all">Alle Produkte</a>';
    main.insertBefore(hero, getAnchor(main));
  }

  /* ── Widget Grid: SVG-Baum + Produkt des Tages ── */
  function injectWidgets() {
    if (!isHome()) return;
    var main = getMain();
    if (!main || main.querySelector('.home-widgets')) return;

    var MAX_V = 50;
    var svg = TREE_SVG[0], left = MAX_V, stage = 0, visits = 0, pct = 0;
    try {
      visits = parseInt(localStorage.getItem('nw_visits') || '0') + 1;
      localStorage.setItem('nw_visits', String(visits));
      stage = Math.min(Math.floor(visits / 10), TREE_SVG.length - 1);
      svg   = TREE_SVG[stage];
      left  = Math.max(0, MAX_V - visits);
      pct   = Math.min(visits / MAX_V, 1);
    } catch(e) {}

    var circ   = 263.9;
    var offset = (circ * (1 - pct)).toFixed(1);
    var done   = visits >= MAX_V;

    var grid = document.createElement('div');
    grid.className = 'home-widgets';

    var bonsai = document.createElement('div');
    bonsai.className = 'home-widget w-bonsai';
    bonsai.innerHTML =
      '<div class="w-greeting">Willkommen zurück</div>' +
      '<div class="w-ring-wrap">' +
        '<svg class="w-ring-svg" viewBox="0 0 100 100" fill="none">' +
          '<circle cx="50" cy="50" r="42" stroke="rgba(0,0,0,0.07)" stroke-width="6"/>' +
          '<circle cx="50" cy="50" r="42" stroke="#10b981" stroke-width="6" ' +
            'stroke-linecap="round" stroke-dasharray="263.9" stroke-dashoffset="' + offset + '" ' +
            'transform="rotate(-90 50 50)"/>' +
          '<circle cx="50" cy="8" r="5" fill="#34d399" opacity="0.95">' +
            '<animateTransform attributeName="transform" type="rotate" ' +
              'from="0 50 50" to="360 50 50" dur="5s" repeatCount="indefinite"/>' +
          '</circle>' +
        '</svg>' +
        '<div class="w-tree-center">' + svg + '</div>' +
      '</div>' +
      '<div class="w-status">' +
        (done ? '✓ GUTSCHEIN AKTION' : 'Noch ' + left + '× zurück') +
      '</div>';
    grid.appendChild(bonsai);

    var crystal = document.createElement('div');
    crystal.className = 'home-widget w-crystal';
    crystal.setAttribute('role', 'button');
    crystal.setAttribute('tabindex', '0');
    crystal.innerHTML =
      '<div class="w-greeting" style="color:#059669">Geheimrabatt</div>' +
      '<div class="w-crystal-ice">' +
        '<div class="w-crystal-glow"></div>' +
        '<div class="w-crystal-pct">10%</div>' +
        '<div class="w-crystal-shine"></div>' +
      '</div>' +
      '<div class="w-status" style="color:#10b981">Tippen zum Freischalten</div>';
    crystal.addEventListener('click', function() {
      window.dispatchEvent(new CustomEvent('fifteen-crystal-tap'));
    });
    grid.appendChild(crystal);

    var searchBar = main.querySelector('.nw-search');
    var hero = main.querySelector('.fifteen-hero');
    var anchor = searchBar && searchBar.nextSibling
      ? searchBar.nextSibling
      : (hero && hero.nextSibling ? hero.nextSibling : getAnchor(main));
    main.insertBefore(grid, anchor);
  }

  /* ── Categories — iOS Settings, vivid icons ── */
  function injectCategories() {
    if (!isHome()) return;
    var main = getMain();
    if (!main || main.querySelector('.cat-list-wrap')) return;

    fetch('/collections.json?limit=16')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cols = (data.collections || []).filter(function(c) {
          return c.handle !== 'frontpage' && c.handle !== 'all' &&
                 c.handle !== 'healthcare-example-products';
        });
        if (!cols.length) return;

        var wrap  = document.createElement('div'); wrap.className = 'cat-list-wrap';
        var title = document.createElement('div'); title.className = 'cat-list-title'; title.textContent = 'Kategorien';
        var list  = document.createElement('div'); list.className = 'cat-list';

        cols.forEach(function(col, idx) {
          var s   = getCat(col.handle);
          var row = document.createElement('a');
          row.className = 'cat-row';
          row.href = '/collections/' + col.handle;
          row.style.setProperty('--delay', (idx * 0.04) + 's');

          var icon = document.createElement('span');
          icon.className = 'cat-row__icon';
          icon.style.background = 'linear-gradient(' + s.g + ')';
          icon.textContent = s.e;

          var name = document.createElement('span'); name.className = 'cat-row__name'; name.textContent = col.title;
          var chev = document.createElement('span'); chev.className = 'cat-row__chevron'; chev.innerHTML = '&#8250;';

          row.appendChild(icon); row.appendChild(name); row.appendChild(chev);
          if (idx < cols.length - 1) row.classList.add('cat-row--border');
          list.appendChild(row);
        });

        wrap.appendChild(title); wrap.appendChild(list);

        var widgets = main.querySelector('.home-widgets');
        var anchor  = widgets && widgets.nextSibling ? widgets.nextSibling : getAnchor(main);
        main.insertBefore(wrap, anchor);
      })
      .catch(function() {});
  }

  /* ── App Store Search Bar ── */
  function injectSearch() {
    if (!isHome()) return;
    var main = getMain();
    if (!main || main.querySelector('.nw-search')) return;
    var form = document.createElement('form');
    form.className = 'nw-search';
    form.action = '/search';
    form.method = 'get';
    form.innerHTML =
      '<div class="nw-search__pill">' +
        '<input class="nw-search__input" type="search" name="q" ' +
          'placeholder="Produkte suchen…" autocomplete="off" ' +
          'autocorrect="off" spellcheck="false"/>' +
      '</div>';
    var hero = main.querySelector('.fifteen-hero');
    main.insertBefore(form, hero ? hero.nextSibling : getAnchor(main));
  }

  /* ── Ship-Bar (hidden — replaced by search) ── */
  function updateShipBar() {}

  /* ── Stock Urgency ── */
  function injectStockUrgency() {
    if (!window.location.pathname.includes('/products/')) return;
    var priceArea = document.querySelector('.product__info-wrapper .price, .product-form');
    if (!priceArea || priceArea.querySelector('.stock-urgent')) return;
    var el = document.createElement('div');
    el.className = 'stock-urgent';
    el.textContent = 'Nur noch ' + (Math.floor(Math.random() * 4) + 2) + ' auf Lager';
    priceArea.insertAdjacentElement('beforebegin', el);
  }

  /* ── Scroll-Reveal ── */
  function initScrollReveal() {
    var sel = '.card-wrapper,.product-card-wrapper,.grid__item,.home-widget,.cat-list-wrap';
    var vh  = window.innerHeight;
    document.querySelectorAll(sel).forEach(function(el) {
      if (el.classList.contains('scroll-reveal')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < vh - 20) el.classList.add('scroll-reveal','in-view');
      else el.classList.add('scroll-reveal');
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
    document.querySelectorAll('.scroll-reveal:not(.in-view)').forEach(function(el) { io.observe(el); });
  }

  /* ── Global tap-pop animation ── */
  function hookTapPop() {
    document.addEventListener('click', function(e) {
      var el = e.target.closest('.card-wrapper,.bundle-card,.home-widget,.cat-row,.pod-card');
      if (!el) return;
      el.classList.remove('tap-pop');
      void el.offsetWidth;
      el.classList.add('tap-pop');
      el.addEventListener('animationend', function() { el.classList.remove('tap-pop'); }, { once: true });
    }, { passive: true });
  }

  /* ── Cart hook ── */
  function hookCart() {
    document.addEventListener('click', function(e) {
      if (e.target.closest('.product-form__submit,button[name="add"]')) {
        var btn = e.target.closest('.product-form__submit,button[name="add"]');
        btn.classList.remove('tap-pop'); void btn.offsetWidth; btn.classList.add('tap-pop');
      }
    });
    if (navigator.vibrate) {
      document.addEventListener('click', function(e) {
        if (e.target.closest('.cat-row,.product-form__submit,button[name="add"],.home-widget')) navigator.vibrate(8);
      });
    }
  }

  /* ── German text overrides ── */
  var DE = {
    'Your cart': 'Dein Warenkorb',
    'Cart': 'Warenkorb',
    'Add to cart': 'In den Warenkorb',
    'Sold out': 'Ausverkauft',
    'Checkout': 'Zur Kasse',
    'Subtotal': 'Zwischensumme',
    'Total': 'Gesamt',
    'Continue shopping': 'Weiter einkaufen',
    'Update cart': 'Warenkorb aktualisieren',
    'Remove': 'Entfernen',
    'Buy it now': 'Jetzt kaufen',
    'Loading': 'Lädt…',
    'View cart': 'Warenkorb ansehen',
    'Free shipping': 'Kostenloser Versand',
    'Shipping': 'Versand',
    'All products': 'Alle Produkte',
    'Search': 'Suchen',
    'Home': 'Start',
    'Collections': 'Kategorien',
    'Products': 'Produkte',
    'Sort by': 'Sortieren nach',
    'Filter': 'Filter',
    'Quantity': 'Menge',
    'Size': 'Größe',
    'Color': 'Farbe',
    'Share': 'Teilen',
    'Close': 'Schließen',
    'Menu': 'Menü',
    'Sale': 'Angebot',
    'New': 'Neu',
    'Unavailable': 'Nicht verfügbar',
    'More payment options': 'Weitere Zahlungsoptionen',
    'or': 'oder',
  };

  function germanify() {
    var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walk.nextNode())) {
      var t = node.textContent.trim();
      if (DE[t]) node.textContent = node.textContent.replace(t, DE[t]);
    }
    document.querySelectorAll('[placeholder]').forEach(function(el) {
      if (DE[el.placeholder]) el.placeholder = DE[el.placeholder];
    });
    document.querySelectorAll('[aria-label]').forEach(function(el) {
      if (DE[el.getAttribute('aria-label')]) el.setAttribute('aria-label', DE[el.getAttribute('aria-label')]);
    });
  }

  /* ── Boot ── */
  function init() {
    germanify();
    initScrollReveal();
    injectHero();
    injectSearch();
    injectWidgets();
    injectCategories();
    injectStockUrgency();
    hookTapPop();
    hookCart();
    setTimeout(initScrollReveal, 900);
    setTimeout(germanify, 1200);
    document.addEventListener('cart:refresh', germanify);
    var cartObs = new MutationObserver(function(muts) {
      muts.forEach(function(m) { if (m.addedNodes.length) germanify(); });
    });
    cartObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
